import { render, staticRenderFns } from "./newBlock.vue?vue&type=template&id=f3ba249c&scoped=true&"
import script from "./newBlock.vue?vue&type=script&lang=js&"
export * from "./newBlock.vue?vue&type=script&lang=js&"
import style0 from "./newBlock.vue?vue&type=style&index=0&id=f3ba249c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ba249c",
  null
  
)

export default component.exports